import { render, staticRenderFns } from "./especializacoes.vue?vue&type=template&id=4ee1fcf4&scoped=true&"
import script from "./especializacoes.vue?vue&type=script&lang=js&"
export * from "./especializacoes.vue?vue&type=script&lang=js&"
import style0 from "./especializacoes.vue?vue&type=style&index=0&id=4ee1fcf4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee1fcf4",
  null
  
)

export default component.exports